import React from "react";
import { RelationsActionButton } from "./RelationsActionButton";

const RelationsActionAlwaysEnabled: React.FC = () => {
  return <RelationsActionButton hasRelations={true} status={"success"} />;
};

export default RelationsActionAlwaysEnabled;
